import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dealApi, dealQueryKeys } from "service/crm/api/deal";
import { DealDetail, UpdateDealPayload } from "types/crm/deal";

export const useUpdateDealMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateDealPayload): Promise<DealDetail> =>
      dealApi.updateDeal(payload),
    onSuccess: (data, variables) => {
      queryClient.setQueryData(dealQueryKeys.detail(variables.dealUuid), data);
      queryClient.invalidateQueries({ queryKey: dealQueryKeys.all });
    },
  });
};
